export const spanish = {
  // Processing Result States
  test_completed_processing_result_states: '¡Prueba completada!',
  video_upload_in_progress_processing_result_states: 'Tu video todavía se está subiendo, por favor espera...',
  test_success_message_processing_result_states:
    '¡Buen trabajo! Has completado la prueba con éxito.',
  test_completed_processing_result_description:
    'Generando tu puntaje... Esto puede tardar un poco',
  preparing_report_processing_result_states: 'Estoy preparando tu informe...',

  // Welcome States
  welcome_message_setup_states_welcome: 'Bienvenido',
  julia_introduction_setup_states_welcome:
    'Soy Julia y te voy a ayudar con la',
  fluency_test_setup_states_welcome: 'Prueba de Fluidez.',
  setup_message_setup_states_welcome:
    'Antes de empezar, necesitamos hacer una configuración rápida. ¿Vamos?',
  next_button_setup_states_welcome: 'Siguiente',

  // Listening Test States
  check_sound_setup_states_listening_test: '¡Vamos a revisar tu sonido!',
  audio_test_message_setup_states_listening_test:
    'Te voy a enviar un audio y ver si puedes escucharme.',
  listening_button_setup_states_listening_test: 'Puedo escuchar',
  not_listening_button_setup_states_listening_test: 'No puedo escuchar',

  // Listening Test Error Container
  hmm_listening_test_error: 'Hmm...',
  not_hearing_listening_test_error: '¿No me escuchas?',
  troubleshoot_message_listening_test_error:
    'Verifica si tus audífonos tienen el volumen bajo o están desconectados. Si el problema persiste, habla con el profesor responsable.',
  try_again_listening_test_error: 'Intentar de nuevo',

  // Timer Tip States
  last_thing_setup_states_timer_tip: '¡Ah! Una última cosa...',
  timer_message_part1_setup_states_timer_tip:
    '¡Presta atención al reloj! Habla durante al menos',
  twenty_seconds_setup_states_timer_tip: '20 segundos',
  timer_message_part2_setup_states_timer_tip:
    'en cada audio. Cuanto más hables, mejor será tu resultado.',
  start_warmup_setup_states_timer_tip: 'Iniciar calentamiento',

  // Recording Test Error States
  hmm_recording_test_error: 'Hmm...',
  microphone_not_good_recording_test_error:
    'Tu micrófono no parece estar funcionando bien.',
  audio_quality_recording_test_error: 'Calidad del audio:',
  microphone_settings_message_recording_test_error:
    'Revisa la configuración de tu micrófono o habla con el profesor responsable.',
  try_again_recording_test_error: 'Intentar de nuevo',

  // Recording User Audio States
  great_recording_user_audio: '¡Genial!',
  almost_there_recording_user_audio: 'Ya casi terminamos',
  record_audio_instruction_recording_user_audio:
    'Ahora graba el audio leyendo la frase de abajo:',
  record_audio_button_recording_user_audio: 'Grabar Audio',

  // Video setup
  video_check_title_video_test: '¡Ya casi estamos!',
  video_check_subtitle_video_test: 'Este es el último ajuste',
  video_check_instruction_video_test:
    'En esta prueba grabaremos tu video y verificaremos que todo funcione correctamente con tu cámara.',
  enable_camera_button_video_test: 'Permitir acceso',
  next_button_video_test_done: 'Continuar',
  camera_disabled_video_test_error: 'La cámara está deshabilitada.',
  camera_enable_instructions_video_test_error:
    'En la barra de direcciones de tu navegador, haz clic en el ícono junto a la dirección del sitio web, selecciona "Permitir cámara" y recarga la página.',
  reload_button_video_test_error: 'Recargar',
  video_check_terms:
    'Al continuar, aceptas que este video será grabado y almacenado.',

  // Word Usage Chart Components
  advanced_words_app_resultado_components_word_usage_chart: 'palabras avanzadas',

  // Export Page
  complete_report_app_resultado_export_page: 'Informe completo:',
  page_number_app_resultado_export_page: 'Página {0}/5',
  performed_by_app_resultado_export_page: 'Realizado por: {0}',
  performed_on_app_resultado_export_page: 'Realizado el: {0}',
  overall_result_app_resultado_export_page: 'Resultado General',
  fluency_analysis_app_resultado_export_page: 'Análisis de fluidez',
  speaking_time_app_resultado_export_page: 'Tiempo hablando',
  seconds_label_app_resultado_export_page: 'Segundos',
  pause_count_app_resultado_export_page: 'Número de pausas',
  pauses_label_app_resultado_export_page: 'Pausas',
  vocabulary_analysis_app_resultado_export_page: 'Análisis de vocabulario',
  pronunciation_analysis_app_resultado_export_page: 'Análisis de pronunciación',
  grammar_analysis_app_resultado_export_page: 'Análisis gramatical',
  coherence_analysis_app_resultado_export_page: 'Análisis de coherencia',

  //Category score
  title_category_score: 'Puntaje por Categoría',
  label_pronunciation_category_score: 'Pronunciación',
  label_fluency_category_score: 'Fluidez',
  label_grammar_category_score: 'Gramática',
  label_coherence_category_score: 'Coherencia',
  label_vocabulary_category_score: 'Vocabulario',

  //Recording audio
  twenty_seconds_recording_audio:
    'Hablaste durante {0} segundos. Intenta hablar más de 20 segundos para obtener un mejor resultado.',

  //User Message
  loading_user_message: 'Cargando',

  //Microphone permission
  click_microphone_permission: 'Haz clic en',
  allow_mic_microphone_permission: 'Permitir Micrófono',
  message_one_microphone_permission:
    'Necesitaremos que tu micrófono esté habilitado, solo haz clic en el botón',
  message_two_microphone_permission: 'Permitir Acceso al Micrófono',
  message_three_microphone_permission: 'y luego haz clic en el botón',
  message_four_microphone_permission: 'Permitir',
  message_five_microphone_permission: 'en tu navegador.',

  // Export Page
  grammar_vocabulary_analysis_app_resultado_export_page:
    'Análisis gramatical y de vocabulario',
  conversation_analysis_app_resultado_export_page: 'Análisis de la conversación',
  advanced_words_usage_app_resultado_export_page:
    'Uso de palabras de nivel avanzado',
  cefr_reference_app_resultado_export_page:
    'Marco Común Europeo de Referencia para las Lenguas',
  total_pause_duration_app_resultado_export_page: 'Duración total de las pausas',
  longest_phrase_without_hesitation_app_resultado_export_page:
    'Longitud de la frase más larga sin vacilación',

  site_demonstration_contact_app_resultado_page: 'Contáctanos',
  demonstration_result_warning:
    'Has completado una prueba demostrativa más corta. Los resultados pueden no reflejar tu fluidez real. Para la experiencia completa, contáctanos.',

  // Resultado Page
  performed_by_app_resultado_page: 'Realizado por: {0}',
  performed_on_app_resultado_page: 'Realizado el: {0}',
  overall_result_app_resultado_page: 'Resultado General',
  oral_expression_level_app_resultado_page: 'Nivel de expresión oral',
  fluency_level_app_resultado_page: 'Nivel de fluidez en inglés',
  conversation_analysis_app_resultado_page: 'Análisis de la conversación',
  fluency_analysis_app_resultado_page: 'Análisis de fluidez',
  conversation_analysis_grammar_errors_app_resultado_page: 'Errores gramaticales',
  conversation_analysis_words_app_resultado_page: 'Palabras',
  conversation_analysis_unique_words_app_resultado_page: 'Palabras únicas',
  grammar_vocabulary_analysis_app_resultado_page:
    'Análisis gramatical y de vocabulario',
  terms_used_section_app_resultado_page: 'Términos usados en las principales gramáticas',
  advanced_words_usage_app_resultado_page: 'Uso de palabras de nivel avanzado',
  conversation_recording_app_resultado_page: 'Grabación de la conversación',
  view_errors_only_app_resultado_page: 'Ver solo errores',
  view_full_conversation_app_resultado_page: 'Ver conversación completa',
  hidden_audio_single_app_resultado_page: 'audio oculto',
  hidden_audio_plural_app_resultado_page: 'audios ocultos',

  // Onboarding Modal
  step_number_onboarding_modal: 'Paso {0}',
  verify_data_onboarding_modal: 'Verificar datos',
  know_you_better_onboarding_modal: 'Queremos conocerte mejor',
  data_verification_onboarding_modal: 'Verificación de datos',
  about_student_onboarding_modal: 'Sobre el estudiante',
  before_start_verification_onboarding_modal:
    'Antes de empezar, necesitamos verificar algunos datos',
  student_data_onboarding_modal: 'Datos del estudiante',
  student_name_onboarding_modal: 'Nombre del estudiante',
  birth_date_onboarding_modal: 'Fecha de nacimiento',
  incorrect_data_onboarding_modal: 'Datos incorrectos',
  confirm_data_onboarding_modal: 'Confirmar Datos',
  questionnaire_completed_onboarding_modal: '¡Cuestionario completado!',
  thanks_information_onboarding_modal:
    'Gracias por la información. ¿Comenzamos la prueba?',
  complete_and_go_to_test_onboarding_modal: 'Completar e ir a la prueba',
  sending_information_onboarding_modal: 'Enviando información...',
  incorrect_registration_onboarding_modal: 'Registro incorrecto',
  cannot_continue_test_onboarding_modal:
    'No será posible continuar con la prueba en este momento. Habla con el profesor responsable.',
  understood_onboarding_modal: 'Entendido',

  // Analysis Card
  score_detail_analysis_card: 'Detalles del puntaje',

  // Fluency Card
  speech_speed_fluency_card: 'Velocidad de habla',
  speech_speed_description_fluency_card:
    'Velocidad de habla incluyendo pausas y tiempo en silencio',
  articulation_speed_fluency_card: 'Velocidad de articulación',
  articulation_speed_description_fluency_card:
    'Velocidad de habla sin considerar el tiempo en silencio y las pausas.',

  // Test Start Message
  test_start_test_start_message: 'Inicio de la prueba',
  great_job_test_start_message: '¡Buen trabajo!',
  now_fluency_test_test_start_message: 'Ahora vamos a la prueba de fluidez.',
  test_start_complete_message_test_start_message_well_done: '¡Buen trabajo!',
  test_start_complete_message_test_start_message_start_over:
    'Ahora vamos a la',
  test_start_complete_message_test_start_message_fluency_test: 'prueba de fluidez.',
  remember_speak_maximum_test_start_message:
    '¡Recuerda hablar todo lo que puedas! ¡Este es el momento de brillar!',

  // Microphone Permission Error
  microphone_disabled_microphone_permission_error: '¡El micrófono está deshabilitado!',
  step_one_microphone_permission_error:
    '1. En la barra de direcciones de tu navegador, haz clic en el ícono junto a la dirección del sitio;',
  step_two_microphone_permission_error: '2. Luego, selecciona Permitir micrófono;',
  step_three_microphone_permission_error: '3. Recarga esta página para intentarlo de nuevo.',
  reload_microphone_permission_error: 'Recargar',

  // Conversation Analysis Labels
  grammar_errors_conversation_analysis: 'Errores gramaticales',
  words_conversation_analysis: 'Palabras',
  unique_words_conversation_analysis: 'Palabras únicas',
  sentences_conversation_analysis: 'Frases',
  average_words_per_sentence_conversation_analysis:
    'Promedio de palabras por frase',
  average_unique_words_per_sentence_conversation_analysis:
    'Promedio de palabras únicas por frase',
  total_syllables_conversation_analysis: 'Total de sílabas',
  words_with_two_or_more_syllables_conversation_analysis:
    'Palabras con más de dos sílabas',
  long_pauses_plural_label_conversation_analysis: 'Pausas largas',
  long_pause_label_conversation_analysis: 'Pausa larga',
  errors_plural_label_conversation_analysis: 'Errores',
  error_label_conversation_analysis: 'Error',

  // Silence Time Chart
  speaking_time_silence_time_chart: 'Tiempo hablando',

  // Login State
  app_name_login: 'FluencyFlow',
  simple_engaging_fluency_test_login: 'Prueba de fluidez simple y atractiva.',
  we_make_it_easier_login: 'Te lo hacemos más fácil.',
  access_code_label_login_form: 'Código de acceso',
  unauthorized_error_login_form: 'Código de acceso no autorizado.',
  test_in_progress_error_login_form: 'La prueba está en progreso o finalizada.',

  // Terms Used Table
  grammar_terms_used_table: 'Gramática',
  quantity_terms_used_table: 'Cant. Términos',
  terms_terms_used_table: 'Términos',

  // Analysis Card
  example_label_analysis_card: 'Ejemplo:',
  fluency_title_analysis_card: 'Fluidez',
  fluency_title_mobile_analysis_card: 'Fluidez',

  // Descriptive Feedback
  descriptive_feedback_title: 'Retroalimentación descriptiva',

  // Speaking Metrics
  speaking_time_speaking_metrics: 'Tiempo hablando',
  seconds_label_speaking_metrics: 'Segundos',
  pause_count_speaking_metrics: 'Número de pausas',
  pauses_label_speaking_metrics: 'Pausas',
  pauses_ideal_label_speaking_metrics: 'Ideal',
  total_pause_duration_speaking_metrics: 'Duración total de las pausas',
  longest_phrase_without_hesitation_speaking_metrics:
    'Longitud de la frase más larga sin vacilación',
  until_speaking_metrics: 'hasta',
  more_speaking_metrics: 'más',

  // Analysis Types
  grammar_analysis_type: 'Gramática',
  vocabulary_analysis_type: 'Vocabulario',
  coherence_analysis_type: 'Coherencia',

  // Ready to Icebreak State
  lets_warm_up_ready_to_icebreak: 'Vamos a',
  warm_up_ready_to_icebreak: '¡Calentar!',
  ready_to_start_warmup_ready_to_icebreak: 'Ahora estamos listos para comenzar el',
  warmup_ready_to_icebreak: 'calentamiento.',
  warmup_description_ready_to_icebreak:
    'Estará basado en una conversación. Te haré preguntas y tú me responderás.',
  next_button_ready_to_icebreak: 'Siguiente',

  // Icebreak Start Message
  warmup_start_icebreak_start_message: 'Inicio del calentamiento',

  // Recording Test Done State
  wonderful_recording_test_done: '¡Maravilloso!',
  hearing_you_recording_test_done: 'Puedo escucharte',
  settings_completed_recording_test_done:
    '¡Configuración completada! Todo está funcionando, así que podemos pasar al siguiente paso.',
  next_button_recording_test_done: 'Siguiente',

  // Fluency Chart
  slow_fluency_chart: 'Lento',
  fast_fluency_chart: 'Rápido',

  // Analysis Card Metrics Details
  // Grammar Metrics
  length_analysis_card: 'Longitud',
  length_title_analysis_card: 'Sobre la Longitud',
  length_about_analysis_card:
    'Esta métrica proporciona información sobre qué tan larga es la respuesta o el mensaje reconocido. La forma en que se conectan las frases influye en el puntaje.',
  length_bad_example_analysis_card:
    'The sun shines brightly. Flowers are beautiful.',
  length_good_example_analysis_card:
    'The sun shines brightly and colorful flowers are beautiful.',

  grammatical_accuracy_analysis_card: 'Precisión Gramatical',
  grammatical_accuracy_title_analysis_card: 'Sobre la Precisión Gramatical',
  grammatical_accuracy_about_analysis_card:
    'Esta métrica analiza la corrección y precisión del uso gramatical, incluyendo aspectos como el uso correcto de los tiempos verbales, la concordancia verbal y el orden adecuado de las palabras. El puntaje también se ve influenciado por la conexión adecuada entre palabras y frases.',
  grammatical_accuracy_bad_example_analysis_card:
    'Hi, my name are Anna. I have 20 years old.',
  grammatical_accuracy_good_example_analysis_card:
    "Hi, my name is Anna and I'm 20 years old.",

  grammatical_range_analysis_card: 'Amplitud Gramatical',
  grammatical_range_title_analysis_card: 'Sobre la Amplitud Gramatical',
  grammatical_range_about_analysis_card:
    'Esta métrica evalúa el nivel de diversidad en las estructuras sintácticas presentes en el mensaje o respuesta reconocida, considerando factores como la variedad de verbos, adjetivos, modificadores adverbiales, entre otros.',
  grammatical_range_bad_example_analysis_card:
    "I'm Anna. I'm Brazilian. I'm 20 years old.",
  grammatical_range_good_example_analysis_card:
    "My name is Anna. I'm a 20-year-old girl from Brazil.",

  // Vocabulary Metrics
  lexical_range_analysis_card: 'Amplitud Léxica',
  lexical_range_title_analysis_card: 'Sobre la Amplitud Léxica',
  lexical_range_about_analysis_card:
    'Esta métrica evalúa la variedad de palabras utilizadas y el grado de uso de vocabulario avanzado y menos común. Tiene que ver con la elección cuidadosa de palabras apropiadas, que ofrecen detalle y claridad en la transmisión del mensaje.',
  lexical_range_bad_example_analysis_card: 'It was a good day. I saw birds.',
  lexical_range_good_example_analysis_card:
    "The weather was just perfect and I couldn't help but notice a variety of birds...",

  collocation_commonality_analysis_card: 'Uso Común de Colocaciones',
  collocation_commonality_title_analysis_card: 'Sobre el Uso Común de Colocaciones',
  collocation_commonality_about_analysis_card:
    'Esta métrica evalúa el uso de combinaciones de palabras, como colocaciones, frases preposicionales y preposiciones dependientes. El objetivo es evaluar en qué medida el habla se alinea con patrones lingüísticos coloquiales y naturales.',
  collocation_commonality_bad_example_analysis_card:
    'I have a brother. I like him.',
  collocation_commonality_good_example_analysis_card:
    'I have a brother and we get along really well.',

  natural_phrases_analysis_card: 'Frases Naturales',
  natural_phrases_title_analysis_card: 'Sobre las Frases Naturales',
  natural_phrases_about_analysis_card:
    'Esta métrica evalúa qué tan natural, coloquial y culturalmente apropiado es el lenguaje utilizado.',
  natural_phrases_bad_example_analysis_card:
    "I am an engineer. I'm responsible for...",
  natural_phrases_good_example_analysis_card:
    "In my role as an engineer I'm in charge of...",

  // Coherence Metrics
  content_words_analysis_card: 'Palabras de Contenido',
  content_words_title_analysis_card: 'Sobre las Palabras de Contenido',
  content_words_about_analysis_card:
    'Esta métrica evalúa la proporción de palabras únicas o palabras de contenido, que son aquellas que contribuyen directamente al significado o contenido, en contraposición a las palabras que principalmente cumplen funciones gramaticales o de enlace.',
  content_words_bad_example_analysis_card: ' I am a teacher and I work a lot',
  content_words_good_example_analysis_card:
    'I am a passionate and experienced teacher who works hard in a renowned school',

  connectors_analysis_card: 'Conectores',
  connectors_title_analysis_card: 'Sobre los Conectores',
  connectors_about_analysis_card:
    'Son palabras o expresiones que establecen relaciones lógicas y cohesión entre las partes de un discurso o texto. Estos conectores ayudan a conectar ideas, indicar contraste, adición, conclusión, negación, entre otras relaciones.',
  connectors_bad_example_analysis_card:
    'Yesterday was a nice day. We went to the beach. The sun was hot.',
  connectors_good_example_analysis_card:
    'Yesterday was a nice day because the sun was hot. So, we went to the beach.',

  pronoun_density_analysis_card: 'Densidad de Pronombres',
  pronoun_density_title_analysis_card: 'Sobre la Densidad de Pronombres',
  pronoun_density_about_analysis_card:
    'Esta métrica evalúa el grado de uso de pronombres en la respuesta. Una alta densidad de pronombres puede indicar un habla más concisa y dinámica, ya que el uso de pronombres evita la repetición excesiva de sustantivos y contribuye a la fluidez y claridad del texto.',
  pronoun_density_bad_example_analysis_card:
    "It's my dad's birthday. I bought a gift for my father.",
  pronoun_density_good_example_analysis_card:
    "It's my father's birthday so I bought him a gift.",

  adverb_diversity_analysis_card: 'Diversidad de Adverbios',
  adverb_diversity_title_analysis_card: 'Sobre la Diversidad de Adverbios',
  adverb_diversity_about_analysis_card:
    'Esta métrica se refiere a la variedad de adverbios utilizados en la respuesta. Una alta densidad de adverbios puede indicar un lenguaje más descriptivo y detallado.',
  adverb_diversity_bad_example_analysis_card: 'I bought a gift for my father.',
  adverb_diversity_good_example_analysis_card:
    "Yesterday, I suddenly remembered it was my father's birthday so I quickly bought him a gift.",

  verb_diversity_analysis_card: 'Diversidad de Verbos',
  verb_diversity_title_analysis_card: 'Sobre la Diversidad de Verbos',
  verb_diversity_about_analysis_card:
    'Esta métrica evalúa el grado y la variedad de verbos en la respuesta. Analizar la densidad verbal en un texto puede aportar información sobre el dinamismo, la acción y la fluidez del habla.',
  verb_diversity_bad_example_analysis_card:
    'I like pasta. I like food. I like chocolate.',
  verb_diversity_good_example_analysis_card:
    'I like pasta. I love food. I enjoy hanging out with friends.',

  // CEFR Levels
  cefr_a1_title: 'Principiante',
  cefr_a1_description:
    'Puede comprender y usar expresiones cotidianas familiares y frases simples relacionadas con situaciones concretas. Es capaz de presentarse, responder preguntas básicas sobre información personal e interactuar de forma limitada, siempre que el interlocutor hable despacio, con claridad y esté dispuesto a ayudar. Maneja un vocabulario restringido a necesidades inmediatas.',

  cefr_a2_title: 'Elemental',
  cefr_a2_description:
    'Puede comunicarse en tareas simples y rutinarias que requieren un intercambio directo de información sobre temas conocidos. Es capaz de describir con frases encadenadas aspectos de su vida diaria, como la familia, el trabajo o el entorno escolar, preferencias y necesidades básicas. Muestra mayor autonomía en interacciones predecibles, aunque todavía con vocabulario limitado y construcciones simples.',

  cefr_b1_title: 'Intermedio',
  cefr_b1_description:
    'Puede comprender los puntos principales de información clara en lenguaje estándar sobre temas conocidos, como el trabajo, el ocio o la escuela. Es capaz de manejar la mayoría de las situaciones que puedan surgir al viajar a países de habla inglesa y puede producir textos simples, conectados y coherentes sobre temas conocidos. Puede expresar opiniones, describir experiencias y justificar brevemente planes y decisiones.',

  cefr_b2_title: 'Intermedio Avanzado',
  cefr_b2_description:
    'Puede comprender las ideas principales de textos más complejos, incluyendo discusiones técnicas en su área de especialidad. Interactúa con suficiente fluidez y espontaneidad para mantener una conversación natural con hablantes nativos. Puede argumentar con claridad, desarrollar puntos de vista, presentar ventajas y desventajas y producir textos bien estructurados y detallados sobre una amplia variedad de temas.',

  cefr_c1_title: 'Avanzado',
  cefr_c1_description:
    'Puede comprender una amplia gama de textos largos y exigentes, identificando significados implícitos, uso figurado y estructuras complejas. Se expresa con fluidez, espontaneidad y eficacia, con un alto grado de precisión léxica y dominio gramatical. Es capaz de adaptar su lenguaje al contexto y al interlocutor, mostrando flexibilidad comunicativa en situaciones académicas, profesionales y sociales complejas.',

  cefr_c2_title: 'Dominio',
  cefr_c2_description:
    'Puede comprender con facilidad prácticamente todo lo que escucha o lee, incluyendo textos abstractos, técnicos o literarios. Es capaz de resumir información de diversas fuentes, reconstruir argumentos y presentar contenido de forma coherente. Se expresa con precisión, naturalidad y espontaneidad, incluso en situaciones altamente complejas o con fuerte carga emocional, demostrando pleno dominio del idioma.',

  // New keys for buttons
  incorrect_data_button_setup_states_welcome_onboarding_modal: 'Datos incorrectos',
  confirm_data_button_setup_states_welcome_onboarding_modal: 'Confirmar Datos',
  complete_and_go_to_test_button_setup_states_welcome_onboarding_modal:
    'Completar e ir a la prueba',
  understood_button_setup_states_welcome_onboarding_modal: 'Entendido',
  reload_button_setup_states_microphone_permission_error: 'Recargar',
  allow_microphone_access_button_setup_states_microphone_permission:
    'Permitir acceso al micrófono',
  access_button_login_form: 'Acceder',
  send_button_recording_audio: 'Enviar',
  got_it_button_recording_audio: 'ENTENDIDO',
  repeat_slower_button_testing_didnt_understand: 'Repetir más despacio',
  next_question_button_testing_didnt_understand: 'Siguiente pregunta',
  didnt_understand_icebreak_testing_didnt_understand: 'No entendí',
  didnt_understand_test_testing_didnt_understand: 'No entendí',
  close_modal_button: 'Cerrar',
  confirm_button_setup_about_student_form: 'Confirmar Datos',
  confirm_topic_button_topic_selector: 'Confirmar',

  steps_introduction: 'Introducción',
  steps_warmup: 'Calentamiento',
  steps_test: 'Prueba',
  steps_result: 'Resultado',

  title_message_topic_selector: 'Selecciona los temas:',

  result_nav_bar_result: 'Resultado',
  result_nav_bar_fluency_analysis: 'Análisis de Fluidez',
  result_nav_bar_grammar_analysis: 'Análisis Gramatical',
  result_nav_bar_conversation_recording: 'Grabación de la Conversación',

  // Demo Access Expired
  title_demo_access_expired: 'Tu acceso ha expirado',
  message_demo_access_expired:
    'No fue posible retomar tu prueba. Ponte en contacto con el aplicador de la prueba para recibir un nuevo enlace de acceso.'
}
